'use client';
import Section from '@repo/ui/src/components/Section';
import { ToutContent } from '@repo/ui/src/components/ToutContent';
import { AmplienceButtonProps, HeaderVariationProps, MetaProps } from '@repo/ui/src/types';
import { classNames } from '@repo/ui/src/utils/classNames';
import { appConfig } from '../../utils/appConfig';

export interface SeriesTitleProps {
  lilHeading?: string;
  heading: string;
  headerVariation: HeaderVariationProps;
  description?: string;
  showDivider: boolean;
  useTexture: boolean;
  align?: 'left' | 'right' | 'center';
  whiteBackground: boolean;
  blackBackground: boolean;
  brandBackground?: boolean;
  includeBottomPadding: boolean;
  darkMode: boolean;
  _meta?: MetaProps;
  button?: Array<AmplienceButtonProps>;
}

const SeriesTitleAndText = ({
  lilHeading,
  heading,
  headerVariation,
  description,
  showDivider,
  useTexture,
  align,
  whiteBackground,
  darkMode,
  blackBackground,
  brandBackground,
  includeBottomPadding,
  button,
}: SeriesTitleProps) => {
  return (
    <div>
      <Section
        gutterX
        gutterY={includeBottomPadding}
        white={whiteBackground}
        black={blackBackground}
        texture={useTexture}
        dark={darkMode}
        brandBackground={brandBackground}
        className={classNames(!includeBottomPadding && 'tw-pb-2 tw-pt-[3.332vw]')}
      >
        <ToutContent
          align={align}
          heading={heading}
          headerVariation={headerVariation}
          headingStyleVariant={headerVariation?.headerVariation ?? 'h2'}
          lilHeading={lilHeading}
          description={description}
          forceDivider={showDivider}
          brandBackground={brandBackground}
          fullWidth
          flexible
          dark={darkMode || blackBackground || brandBackground}
          buttons={button}
          buttonNegative={appConfig.isMeater && darkMode}
          className={classNames(
            button && 'tw-mb-6',
            appConfig.isMeater && darkMode && '[&_.divider]:tw-bg-black',
          )}
        />
      </Section>
    </div>
  );
};

export default SeriesTitleAndText;
